export class Bem {
    constructor(block) {
        this.block = (...modifiers) => {
            return this.modifiers(this._block)(...modifiers);
        };
        this.element = (element) => {
            return this.modifiers(`${this._block}__${element}`);
        };
        this.modifiers = (blockElement) => {
            return function createBem(...modifiers) {
                const bemModifiers = modifiers.filter(Boolean).map((modifier) => `${blockElement}--${modifier}`);
                return [blockElement, ...bemModifiers].join(' ').toLowerCase();
            };
        };
        this.concat = (className) => {
            if (className) {
                return `${this._block} ${className}`;
            }
            return this._block;
        };
        this._block = block;
    }
    static create(block) {
        return new Bem(block);
    }
}
export function isValidLength(length) {
    const cssLengthRegex = RegExp('^(auto|0)$|^[+-]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc)$', 'g');
    return cssLengthRegex.test(length);
}
export function addClass(...params) {
    return params
        .filter(Boolean)
        .reduce((acc, next) => {
        acc.push(next);
        return acc;
    }, [])
        .join(' ');
}
//# sourceMappingURL=css.js.map